import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WorkRequestsRegistry } from '@/features/work-requests';

export const OperationsRequestsView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <WorkRequestsRegistry
      roleContext="OPERATIONS_PARTNER"
      onBack={() => navigate('/app/operations')}
      isStandalone={true}
    />
  );
};
